import { updateSharedIntegration } from "api/Integrations";
import SoftBox from "components/SoftBox";
import SoftSelect from "components/SoftSelect";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ThemedRemoveCircleOutlineIcon } from "assets/CXFIcons/Actions";
import { updateSharedIntegration as updateSharedIntegrationAction } from "redux/actions/portal/integrationActionCreator";

const options = {
  status: [
    { value: "readOnly", label: "Read Only" },
    { value: "editor", label: "Editor" },
  ],
};

export const UserRole = ({ user, handleSetUserToBeRemoved, isAllowedToEdit }) => {
  const [accessType, setAccessType] = useState(options.status[0]);
  const [isUpdatingAccessType, setIsUpdatingAccessType] = useState(false);
  const { sharedIntegrations } = useSelector((store) => store.portal.integrations);
  const dispatch = useDispatch();

  const getSharedIntegration = () => {
    return sharedIntegrations.find(
      (sharedIntegration) => sharedIntegration.shared_user_id === user.auth0_id
    );
  };

  const handleUpdateUserAccessType = async (newValue) => {
    if (isUpdatingAccessType || !isAllowedToEdit) return;

    setIsUpdatingAccessType(true);

    const input = {
      ...getSharedIntegration(),
      access_type: newValue.value,
    };

    const result = await updateSharedIntegration(input);

    setIsUpdatingAccessType(false);

    if (!result) {
      toast.error("Something went wrong, Please try again");
    }

    if (result?.isSuccessful) {
      toast.success("User access type successfully updated");

      dispatch(updateSharedIntegrationAction(input));
      setAccessType(newValue);
    }
  };

  useEffect(() => {
    const sharedIntegrationUser = sharedIntegrations.find(
      (sharedIntegration) => sharedIntegration.shared_user_id === user.auth0_id
    );

    if (sharedIntegrationUser) {
      setAccessType(
        options.status.find((status) => status.value === sharedIntegrationUser.access_type) ??
          options.status[0]
      );
    }
  }, []);

  return (
    <SoftBox>
      <SoftBox
        sx={{
          alignItems: "center",
          display: "flex",
        }}
      >
        <SoftSelect
          className="flow-user-select"
          placeholder="Filter Status"
          options={options?.status?.sort((a, b) => a.label.localeCompare(b.label))}
          hideSelectedOptions={false}
          onChange={handleUpdateUserAccessType}
          value={accessType}
          isDisabled={user.isOwner || !isAllowedToEdit}
        />
        {!user.isOwner && isAllowedToEdit && (
          <button
            className="flow-user-remove"
            style={{
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
            }}
            onClick={() => handleSetUserToBeRemoved(user)}
          >
            <ThemedRemoveCircleOutlineIcon width="32px" height="32px" />
          </button>
        )}
      </SoftBox>
    </SoftBox>
  );
};
